import React from 'react';
import { Link } from '@mui/material';

// Finding text arrives from the collector in Slack link markup ("<https://url|label>",
// occasionally "<https://url>") because one formatter feeds both Slack alerts and the
// dashboard cards. Render those as real links instead of leaking the raw markup.
const SLACK_LINK = /<(https?:\/\/[^|>\s]+)(?:\|([^>]*))?>/g;

export default function FindingText({ text }: { text: string }) {
  const nodes: React.ReactNode[] = [];
  const re = new RegExp(SLACK_LINK.source, 'g');
  let last = 0;
  let m = re.exec(text);
  while (m !== null) {
    if (m.index > last) nodes.push(text.slice(last, m.index));
    nodes.push(
      <Link key={m.index} href={m[1]} target="_blank" rel="noopener">
        {m[2] || m[1]}
      </Link>,
    );
    last = m.index + m[0].length;
    m = re.exec(text);
  }
  if (last < text.length) nodes.push(text.slice(last));
  return <>{nodes}</>;
}
